import React from 'react';
import { IonIcon } from '@ionic/react';
import { location, locationOutline, chevronDownOutline } from 'ionicons/icons';
import { useLocationContext } from '@/lib/geo/LocationContext';
import { PLACE_LABEL } from '@/lib/geo/places';
import { LocationPanel } from './LocationPanel';

const badgeStyle: React.CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: '8px',
  width: '100%',
  padding: '8px 16px',
  borderRadius: '999px',
  background: 'rgba(255,255,255,0.16)',
  border: '1px solid rgba(255,255,255,0.35)',
  backdropFilter: 'blur(8px)',
  WebkitBackdropFilter: 'blur(8px)',
  color: '#ffffff',
  fontSize: '0.85rem',
  maxWidth: '500px',
  boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
  cursor: 'pointer',
};

const pulseKeyframes = `
@keyframes bp-pin-pulse {
  0%, 100% { opacity: 1; transform: scale(1); }
  50% { opacity: 0.45; transform: scale(0.82); }
}
`;

export const LocationBadge: React.FC = () => {
  const { status, name, placeType, panelOpen, setPanelOpen } = useLocationContext();

  const label =
    status === 'loading'
      ? 'Detecting your location…'
      : status === 'ready' && name
        ? `Opportunities near ${name}${placeType ? ` · (${PLACE_LABEL[placeType] ?? placeType})` : ''}`
        : 'Location off — tap to set area';

  return (
    <div
      style={{
        position: 'relative',
        display: 'inline-flex',
        alignSelf: 'center',
        marginBottom: '14px',
        maxWidth: '500px',
      }}
    >
      <style>{pulseKeyframes}</style>
      <button
        type="button"
        onClick={() => setPanelOpen(!panelOpen)}
        aria-expanded={panelOpen}
        aria-haspopup="dialog"
        aria-label="Change your location"
        style={badgeStyle}
      >
        <span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          {status === 'loading' ? (
            <IonIcon
              icon={location}
              style={{ fontSize: '1rem', animation: 'bp-pin-pulse 1.2s ease-in-out infinite' }}
            />
          ) : status === 'unavailable' ? (
            <IonIcon icon={locationOutline} style={{ fontSize: '1rem', opacity: 0.8 }} />
          ) : (
            <IonIcon icon={location} style={{ fontSize: '1rem', color: '#9ecbff' }} />
          )}
          <span aria-live="polite">{label}</span>
        </span>
        <IonIcon
          icon={chevronDownOutline}
          style={{
            fontSize: '0.95rem',
            opacity: 0.85,
            transform: panelOpen ? 'rotate(180deg)' : 'none',
            transition: 'transform 0.2s ease',
            flexShrink: 0,
          }}
        />
      </button>
      <LocationPanel />
    </div>
  );
};
